export default __webpack_public_path__ + "static/media/Version (2) - LOTR_08.08695437.jpg";